<template>
  <j-actions :type="type">
    <a-menu>
      <a-menu-item
        @click="onEdit"
        v-if="$auth.granted(acl.offices.update)">
        <a-icon type="form" class="text-secondary" />
        {{ $t('msg.office.action.edit') }}
      </a-menu-item>
      <a-menu-item
        @click="onActivate"
        v-if="$auth.granted(acl.offices.update) && item.activation !== 'ACTIVE'">
        <a-icon type="check-circle" class="text-secondary" />
        {{ $t('msg.office.action.activate') }}
      </a-menu-item>
      <a-menu-item
        class="text-danger"
        @click="onDeactivate"
        v-if="$auth.granted(acl.offices.update) && item.activation === 'ACTIVE'">
        <a-icon type="close-circle" class="text-danger" />
        {{ $t('msg.office.action.deactivate') }}
      </a-menu-item>
    </a-menu>
  </j-actions>
</template>

<script>
import lms from '@/api/lms'
import acl from '@/auth/acl'
import JActions from '@/views/shared/base/actions'

export default {
  props: [
    'item',
    'type',
  ],
  components: {
    JActions,
  },
  data: function () {
    return {
      acl,
    }
  },
  methods: {
    onEdit() {
      this.$router.push(`/offices/${this.item.id}/update`)
    },
    onActivate() {
      lms.office.activate(this.item.id)
        .then(() => {
          this.$message.success(this.$t('msg.office.activated'))
          this.$emit('changed')
        })
    },
    onDeactivate() {
      lms.office.deactivate(this.item.id)
        .then(() => {
          this.$message.success(this.$t('msg.office.deactivated'))
          this.$emit('changed')
        })
    },
  },
}
</script>
